import React from "react";
import { connect } from 'react-redux';
import { Select, Row, Col } from "antd";
import PropTypes from 'prop-types';
import { PlaceHolder, MultiSelectWrapper } from "./styles";
import { multiSelectOption } from "../Pages/actions";
import { CustomSelectBox } from "./../../../CommonComponents/commonStyles";
let dropDownOptions = [];
const Option = Select.Option;
export class MultiSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      size: "large",
      children: this.props.menu,
      optionsAnt: [],
      optionInfo: ["A", "B", "C", "D", "E", "F"],
      info: false,
    };
    this.configureOptions = this.configureOptions.bind(this);
    this.handleMultiSelectChange = this.handleMultiSelectChange.bind(this);
  }

  componentDidMount() {
    this.configureOptions(this.props);
    if( document.querySelector(".ant-select-search__field"))
    {
      document.querySelector(".ant-select-search__field").setAttribute("aria-label","multi select")
    
    }
  }

  configureOptions = async (newProps) => {
    let optionsAnt = newProps.options ? newProps.options : null;
    let newOption =
      optionsAnt &&
      optionsAnt.map((x, index) => (
        <Option key={`option-${index}`} value={x}>
          {x}
        </Option>
      ));
    dropDownOptions = newOption;
    this.setState({
      optionsAnt: newOption
    });
  }

  componentWillReceiveProps(nextProps) {
    this.configureOptions(nextProps);
  }

  handleMultiSelectChange(value) {
    let optionsArray = this.props.options;
    let newValue = value;
    if (value.length > 0) {
      if (value[value.length - 1] === "All") {
        newValue = ["All"]
      } else if (value[0] === "All") {
        newValue = value.slice(1)
      } else if (value[0].includes('Custom Dates') && value.length > 1) {
        newValue = value.slice(1)
      }
    }
    this.props.handleDropper(newValue);
    if (newValue.length > 0 && newValue[newValue.length - 1] === "Custom Dates") {

    } else {
      this.props.multiSelectOption(newValue, optionsArray);
    }
  }

  render() {
    return (
      <Row data-test="document-centre-multi-select">
        <Col lg={24} xs={0}>
          <MultiSelectWrapper id="docCentreMultiselect">
            <CustomSelectBox
              width="200"
              mode="tags"
              showArrow={true}
              defaultValue={[]}
              getPopupContainer={() => document.getElementById('docCentreMultiselect')}
              placeholder={<PlaceHolder>-Select-</PlaceHolder>}
              onChange={this.handleMultiSelectChange}
              value={this.props.multiSelectValue}
            >
              {dropDownOptions}
            </CustomSelectBox>
          </MultiSelectWrapper>
        </Col>
        <Col lg={0} xs={24}>
          <MultiSelectWrapper id="docCentreMultiselectMobile">
            <CustomSelectBox
              width="200"
              mode="tags"
              showArrow={true}
              defaultValue={[]}
              getPopupContainer={() => document.getElementById('docCentreMultiselectMobile')}
              placeholder={<PlaceHolder>-Select-</PlaceHolder>}
              onChange={this.handleMultiSelectChange}
              value={this.props.multiSelectValue}
            >
              {dropDownOptions}
            </CustomSelectBox>
          </MultiSelectWrapper>
        </Col>
      </Row>
    );
  }
}


MultiSelect.propTypes = {
  multiSelectValue: PropTypes.array,
  options: PropTypes.array,
  handleDropper: PropTypes.func.isRequired,
  multiSelectOption: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => ({
  multiSelectValue: state.getIn(['documentCentre', 'multiSelectValue']),
});

export const mapDispatchToProps = dispatch => {
  return {
    multiSelectOption: (value, isCustomDate) => dispatch(multiSelectOption({ value: value, isCustomDate: isCustomDate })),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiSelect);
